
// 同步可用(异步有BUG)
// 异步使用工具中的flyIn

let start: any = null
let open: any = false
const action = (startConfig, endConfig, container = document.body) => {
  return new Promise((resolve) => {
    // 元素
    const body = container
    const flyRound = document.createElement('div')
    const flyChild = document.createElement('div')
    flyRound.appendChild(flyChild)
    body.appendChild(flyRound)

    // 位置信息
    const { top: startTop, left: startLeft } = startConfig
    const { top: endTop, left: endLeft } = endConfig
    // 样式
    flyRound.setAttribute('style', `
      transition: all .6s cubic-bezier(0, 0.74, 0.53, 1.09) 0s;
      position: absolute;
      top: ${startTop}px;
      left: ${startLeft}px;
      z-index: 2000`)

    flyChild.setAttribute('style', `
      width: 20px;
      height: 20px;
      border-radius: 50%;
      transition: all .6s ease 0s;
      background: #1B66FF`)

    const flyTimer = setTimeout(() => {
      flyRound.style.transform = `translate3d(0, ${(endTop - startTop)}px, 0)`
      flyChild.style.transform = `translate3d(${(endLeft - startLeft)}px, 0, 0)`
      const removeTimer = setTimeout(() => {
        clearTimeout(flyTimer)
        clearTimeout(removeTimer)
        body.removeChild(flyRound)
        resolve(true)
      }, 600)
    }, 1)
  })
}

const run = async () => {
  const end = document.getElementById('taskMsg')
  if (start && end) {
    const startConfig = start.getBoundingClientRect()
    const endConfig = end.getBoundingClientRect()
    try {
      await action(
        { top: startConfig.top, left: startConfig.left },
        { top: endConfig.top, left: endConfig.left },
      )
    } catch(e) {
      console.log('添加任务失败！')
    }
  }
}

export default function register(app) {
  app.directive('fly', {
    unmounted(el) {
      el.removeEventListener('click', run)
    },
    updated(el, binding) {
      start = el
      open = binding.value
    },
    beforeMount(el, binding) {
      start = el
      open = binding.value
      start.addEventListener('click', run)
    }
  })
}
